import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EDispatchDate = {
  title: {
    name: ['تاریخ اعزام', 'تاریخ های اعزام'],
  },
  routes: PATH_DASHBOARD.dispatchDate,
  api: api.dispatchDate,
  // enum: {
  //   array: Object.values(caravanTabType),
  //   object: caravanTabType,
  // },
};

export default EDispatchDate;
